<template>
  <v-card class="mb-1 bpmExpandedPanel">
    <v-card-title @click="togglePanel" class="pa-0 bpmExpandedPanel__header">
      <v-system-bar color="panel" dark window style="width: 100%" class="bpmExpandedPanel__header__items">
        <v-btn flat >
          {{ name }}
        </v-btn>    
        <span class="bpmExpandedPanel__header__counter">| {{ count }}</span>
        <v-spacer />
        <v-icon >{{showBody ? 'mdi-chevron-up' : 'mdi-chevron-down'}}</v-icon>
      </v-system-bar>
    </v-card-title>
    <template v-if="showBody">
      <v-card-text class="px-2 py-2 overflow-auto">
        <slot></slot>
      </v-card-text>   
    </template>
  </v-card>
</template>

<script>
export default {
  name: "ExpandPanel",
  data() {
    return {
      showBody: this.opened,
    };
  },
  props: {
    name: {
      type: String,
      required: true
    },
    items: {
      type: Array
    },
    opened: {
      type: Boolean
    },
    count: {
      type: Number
    }
  },
  methods: {
    togglePanel() {
      this.showBody ? (this.showBody = false) : (this.showBody = true);
    }
  }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/ExpandedPanel/ExpandedPanel.vue